module.exports = __webpack_public_path__ + "static/media/Akkurat-Mono.a1d180ff.eot";